module.exports = __webpack_public_path__ + "img/ky.be573085.png";